import React, { ReactNode } from "react";
import { mergeStyleSets } from "@fluentui/react";
import HeaderPanel from "./HeaderPanel";

const classNames = mergeStyleSets({
  message: {
    fontSize: "1.050rem",
    fontWeight: "bold",
    display: "flex",
    justifyContent: "center",
    width: "100%",
    color: "var(--color-blue)",
    padding: "1rem 1rem 0 1rem",
  },
  icon: {
    width: "220px",
    height: "100px",
    objectFit: "contain",
  },
  iconWrapper: { margin: "5rem auto 1.5rem auto", display: "flex", justifyContent: "center" },
});

interface OperationCompletedProps {
  message: string;
  icon: string;
  alt: string;
  title?: string;
  children?: ReactNode;
}

export const OperationCompletedPanel = (props: OperationCompletedProps) => {
  const { message, icon, alt, title, children } = props;

  return (
    <div>
      {title && <HeaderPanel applyPadding>{title}</HeaderPanel>}
      <div className={classNames.iconWrapper}>
        <img alt={alt} src={icon} className={classNames.icon} />
      </div>

      <div>
        <span className={classNames.message}>{message}</span>
        {children && <span className={classNames.message}>{children}</span>}
      </div>
    </div>
  );
};
